import * as types from '../types'

// get user from localStorage
const initialState = {
    loading: false,
    loginUser: {},
    loggedIn: false,
    error: null,
    verifyOtp: false,
}

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.LOGIN:
            return {
                ...state,
                loginUser: action.payload,
                loading: false,
                error: null
            }
        case types.LOG_OUT:
            return {
                ...state,
                loginUser: null,
                loggedIn: false,
                accounts: null,
                loading: false,
                error: null
            }
        case types.SET_LOADING:
            return {
                ...state,
                loading: true,
                error:null
            }
        case types.SEND_LOGIN_OTP:
            return {
                ...state,
                // verifyOtp: false,
                otpRequired: true,
                loading: false,
                ablToken: action.payload
            }
        case types.FORGET_PASSWORD:
            return {
                ...state,
                info: true,
                loading: false,
            }
        case types.VERIFY_AND_SET_PASSWORD:
            return {
                ...state,
                info: false,
                loading: false,
            }
        case types.RESET_LOADING:
            return {
                ...state,
                loading: false,
                error:null
            }
        case types.RESET:
            return {
                ...state,
                loading: false,
                error:null,
                otpRequired: false,
                info: false,
            }
        case types.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        default:
            return state
    }
}